import angular from 'angular';

import CreateStudentAccountController from './create-student-account-controller';

const createStudentAccount = angular.module('createStudentAccount', []);
createStudentAccount.controller('CreateStudentAccountController', CreateStudentAccountController);

export default createStudentAccount.name;
